import React from 'react';

// Barra informativa (nessun conto alla rovescia: nessuna urgenza inventata).
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-59" data-mp="306tmdtd7wu66">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-60" data-mp="2ve0h94du7jtk">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-61" data-mp="2rbdvnl7rev4t">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-62" data-mp="2mfyjqytbb9b1" />
        </span>
        <span className="text-stone-50/85" data-id="element-63" data-mp="2hdpmhq9epl34">
          <span className="hidden sm:inline" data-id="element-64" data-mp="2cg7pmy8nywbh">9 volumi + 5 bonus · Accesso immediato · Garanzia di 7 giorni</span>
          <span className="sm:hidden" data-id="element-65" data-mp="28f47u6722q7m">9 volumi + 5 bonus · Accesso immediato</span>
        </span>
      </div>
    </div>;
}